/*
  Ilmaisen toimituksen raja markkinoille, joiden raja on asetettu euroina mutta asiakas maksaa
  muussa valuutassa (SE, NO, DK, PL). Shopifyn alennus muuntaa euroinimin päivän kurssilla, ja
  sama kurssi on sivulla muuttujassa Shopify.currency.rate. Palkki ja tekstit lasketaan sillä,
  jotta kori lupaa ilmaisen toimituksen täsmälleen silloin kun kassa sen antaa.
  Liquid: snippets/free-shipping-bar.liquid ja snippets/free-shipping-limit.liquid.
*/
(() => {
  if (window.freddyFreeShipping) return;

  const decode = (html) => {
    const el = document.createElement('div');
    el.innerHTML = html;
    return el.textContent;
  };

  // Muotoilu otetaan Liquidin money-suodattimen näytteestä (123456789 senttiä), jotta erottimet ja
  // valuuttamerkki ovat samat kuin muualla teemassa: "1 234 567,89 kr", "1.234.567,89 zł".
  const formatMoney = (cents, sampleHtml, wholeUnits) => {
    const sample = decode(sampleHtml);
    const numeric = sample.match(/\d[\d\s.,'  ]*\d/);
    if (!numeric) return null;
    const num = numeric[0];
    const decimalMatch = num.match(/([.,])89$/);
    const thousandSep = /\d/.test(num[1]) ? '' : num[1];
    let units = Math.floor(cents / 100);
    let rest = cents % 100;
    if (wholeUnits || !decimalMatch) {
      units = Math.ceil(cents / 100);
      rest = null;
    }
    let out = String(units).replace(/\B(?=(\d{3})+(?!\d))/g, thousandSep);
    if (rest !== null) out += decimalMatch[1] + String(rest).padStart(2, '0');
    return sample.replace(num, out);
  };

  const rate = () => {
    const value = parseFloat(window.Shopify && window.Shopify.currency && window.Shopify.currency.rate);
    return value > 0 ? value : null;
  };

  const setIfChanged = (el, attr, value) => {
    if (el.getAttribute(attr) !== value) el.setAttribute(attr, value);
  };

  const update = () => {
    const r = rate();
    if (!r) return;

    document.querySelectorAll('[data-free-shipping-limit]').forEach((el) => {
      const threshold = Math.ceil(parseInt(el.dataset.freeShippingLimit, 10) * r);
      const text = formatMoney(threshold, el.dataset.freeShippingMoneySample, true);
      if (text && el.textContent !== text) el.textContent = text;
    });

    document.querySelectorAll('.free-shipping-bar[data-free-shipping-base]').forEach((bar) => {
      const threshold = Math.ceil(parseInt(bar.dataset.freeShippingBase, 10) * r);
      const cart = parseInt(bar.dataset.freeShippingCurrentCart, 10) || 0;
      const progress = Math.max(0, Math.min(1, cart / threshold));
      const met = progress >= 1;
      setIfChanged(bar, 'data-free-shipping-amount', String(threshold));
      setIfChanged(bar, 'data-free-shipping-progress', met ? '1' : String(progress));
      bar.style.setProperty('--free-shipping-progress', String(progress));
      bar.style.setProperty('--free-shipping-bar-color', met ? bar.dataset.colorMet : bar.dataset.colorUnder);

      const message = bar.querySelector('.free-shipping-bar__message--no');
      const template = bar.querySelector('template[data-free-shipping-deficit]');
      if (message && template && !met) {
        const deficit = formatMoney(threshold - cart, bar.dataset.freeShippingMoneySample, false);
        const html = template.innerHTML.replace('[[amount]]', deficit);
        if (message.innerHTML !== html) message.innerHTML = html;
      }
      setIfChanged(bar, 'data-free-shipping-ready', '');
    });
  };

  // Kori päivittää palkin attribuutit ja tekstin palvelimelta, jolloin arvot palaavat euroiksi;
  // lasketaan uudelleen seuraavassa ruudussa. Kirjoitukset tehdään vain kun arvo muuttuu.
  let scheduled = false;
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      update();
    });
  };

  window.freddyFreeShipping = { update };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', update);
  } else {
    update();
  }
  new MutationObserver(schedule).observe(document.documentElement, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ['data-free-shipping-current-cart', 'data-free-shipping-base']
  });
})();
